import { SkillTypeEnum } from '@/api/dx-backend';

/**
 * The accent colour a skill type carries through the HUD — the action cell's
 * border and glow, and the frame of the caption that names it on hover.
 *
 * Single source of truth on purpose: these used to be spelled out once per type
 * in the cell's stylesheet, so a caption drawn anywhere else had no way to agree
 * with the cell the player is actually pointing at.
 */
export const SKILL_TYPE_ACCENT: Record<string, string> = {
  [SkillTypeEnum.Attack]: '#ff1744',
  [SkillTypeEnum.Defense]: '#00e5ff',
  [SkillTypeEnum.Heal]: '#00ff6a',
  [SkillTypeEnum.Buff]: '#ffc107',
  [SkillTypeEnum.Debuff]: '#e2453f',
  [SkillTypeEnum.Utility]: '#9e9e9e',
  [SkillTypeEnum.Special]: '#9a6bff',
  [SkillTypeEnum.Summon]: '#e040fb'
};

/** Flow cyan — used where nothing skill-typed is involved (the HUD triggers). */
export const DEFAULT_ACCENT = '#00bfff';

export const accentForSkillType = (type?: string | null): string =>
    (type && SKILL_TYPE_ACCENT[type]) || DEFAULT_ACCENT;

/** `"#ff1744"` -> `"255, 23, 68"`, so stylesheets can vary alpha off one variable. */
export const accentRgb = (hex: string): string => {
  const value = hex.replace('#', '');
  const full = value.length === 3 ? value.split('').map((c) => c + c).join('') : value;
  const int = parseInt(full, 16);
  return `${(int >> 16) & 255}, ${(int >> 8) & 255}, ${int & 255}`;
};
